// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2EcBo","inputWrap":"styles_inputWrap__1b65e","input":"styles_input__20OdJ"};